export default __webpack_public_path__ + "static/media/slick-pizza.7e14083e.jpg";